import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "a00954c2-9cd6-421a-89b3-5f6956ca5dee",
  publicId: "1",
  name: "Definition, what is a wave, speed of  sound, physical quantities involved, order of magnitude",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
